// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class Highlight360Module extends ModuleBase {
  public mouseMoving: boolean = false;
  public mouseInitX: number = 0;
  public touchMoving: boolean = false;
  public touchInitX: number = 0;
  public imgPath: string = "";
  public activeImg: number = 0;
  public imgCount: number = 0;
  public speed: number = 5;
  public speedLimiter: number = 0;
  public spinnerImages: Array<any> = [];
  public highlights: object = {};
  public highlightsMobile: Array<any> = [];
  public popupOpen: boolean = false;
  public popup: object = {
    image: "",
    headline: "",
    text: "",
  };

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  public async created() {
    this.prepareHighlights();

    //load first 4 images
    this.prepareImages(0, 3).then(() => {
      if (this.spinnerImages.length) this.imgPath = this.spinnerImages[0].src;

      //next 4 images
      this.prepareImages(4, 7).then(() => {
        //next 10 images
        this.prepareImages(8, 17).then(() => {
          //next 18 images
          this.prepareImages(18, 35).then(() => {});
        });
      });
    });
  }

  public mounted() {
    document.addEventListener("mouseup", this.handleMouseUp);
    document.addEventListener("touchend", this.handleTouchEnd);

    this.imgCount = this.instance["section_images"].length;
  }

  public destroyed() {
    document.removeEventListener("mouseup", this.handleMouseUp);
    document.addEventListener("touchend", this.handleTouchEnd);
  }

  public prepareHighlights() {
    for (let i = 0; i < this.instance["section_images"].length; i++) {
      if (this.instance["section_images"][i].highlights.length) {
        this.highlights[i] = this.instance["section_images"][i].highlights;

        //check if one of the highlights should be shown on mobile
        this.instance["section_images"][i].highlights.forEach((highlight) => {
          if (highlight.mobile && highlight.bottom && highlight.right)
            this.highlightsMobile.push(highlight);
        });
      }
    }
  }

  public async prepareImages(start: number, end: number) {
    //for cases with image count < 36
    if (start < end) {
      let finalEnd = Math.min(end, this.instance["section_images"].length - 1);
      for (start; start <= finalEnd; start++) {
        let img = new Image();
        img.src = this.getTranslatedImage(
          this.instance["section_images"][start].image,
          this.lang,
          "full"
        );
        this.spinnerImages.push(img);
      }
    }
  }

  public handleMouseDown(event: MouseEvent) {
    this.mouseMoving = true;
    this.mouseInitX = event.pageX;
  }

  public handleMouseUp() {
    this.mouseMoving = false;
  }

  public handleMouseMove(event: MouseEvent) {
    if (this.mouseMoving) {
      if (event.pageX < this.mouseInitX) this.handleMovement("left");
      else if (event.pageX > this.mouseInitX) this.handleMovement("right");

      this.mouseInitX = event.pageX;
    }
  }

  public handleTouchStart(event: TouchEvent) {
    event.preventDefault();
    this.touchMoving = true;
    this.touchInitX = event.touches[0].pageX;
  }

  public handleTouchEnd() {
    this.touchMoving = false;
  }

  public handleTouchMove(event: TouchEvent) {
    if (this.touchMoving) {
      if (event.touches[0].pageX < this.touchInitX) this.handleMovement("left");
      else if (event.touches[0].pageX > this.touchInitX)
        this.handleMovement("right");

      this.touchInitX = event.touches[0].pageX;
    }
  }

  public handleMovement(direction) {
    if (this.popupOpen) return;

    this.speedLimiter++;

    if (this.speedLimiter < this.speed) return;
    else this.speedLimiter = 0;

    if (direction == "left") {
      if (this.activeImg >= 0 && this.activeImg < this.imgCount - 1)
        this.activeImg++;
      else this.activeImg = 0;
    } else {
      if (this.activeImg >= 0 && this.activeImg - 1 >= 0) this.activeImg--;
      else this.activeImg = this.imgCount - 1;
    }

    this.imgPath = this.spinnerImages[this.activeImg].src;
  }

  public openPopup(spin, index) {
    this.popup["headline"] = this.highlights[spin][index]["headline"];
    this.popup["image"] = this.highlights[spin][index]["image"];
    this.popup["text"] = <HTMLElement>this.highlights[spin][index]["text"];

    this.popupOpen = true;
  }

  public closePopup() {
    this.popupOpen = false;
  }
}
